import { useEffect, useState } from 'react';

import { getToken } from '@platform/core/auth';

export const useGetToken = () => {
  const [authToken, setAuthToken] = useState<string | undefined>();

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getToken();
      setAuthToken(token);
    };
    fetchToken();
  }, []);

  return authToken;
};
